import "core-js/modules/es6.function.name";
import Flickity from 'flickity';
import 'flickity/css/flickity.css';
import BumpModal from '@/components/BumpEgg/BumpModal/BumpModal';
export default {
  name: 'Result',
  components: {
    BumpModal: BumpModal
  },
  props: {
    awardList: {
      type: Array,
      required: true
    },
    isFromBump: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      currentIndex: 0
    };
  },
  settingKey: '碰蛋结果',
  setting: {
    按钮: {
      type: 'object',
      properties: {
        查看奖品: 'https://puui.qpic.cn/vupload/0/20190624_1561376717348_xjacoxr72c.png/0',
        继续碰蛋: 'https://puui.qpic.cn/vupload/0/20190624_1561376719958_ij8hkcvyjba.png/0',
        我再试试: 'https://puui.qpic.cn/vupload/0/20190624_1561379167558_rfswdp7trl.png/0'
      }
    },
    奖品背景: 'https://puui.qpic.cn/vupload/0/20190624_1561376177028_igqm50ryrb.png/0',
    左右按钮: 'https://puui.qpic.cn/vupload/0/20190624_1561377250159_z7rsi4ngooc.png/0',
    冠名: ''
  },
  computed: {
    currentAward: function currentAward() {
      return this.awardList[this.currentIndex];
    },
    buttons: function buttons() {
      var btnImgs = this.setting.按钮;

      if (this.currentAward.my.result) {
        return {
          left: btnImgs.查看奖品,
          leftAction: this.toAwardPage,
          leftReport: this.reportData.碰蛋结果弹框.查看我的奖品,
          right: btnImgs.继续碰蛋,
          rightAction: this.cancel,
          rightReport: this.reportData.碰蛋结果弹框.继续碰蛋
        };
      } else {
        return {
          left: btnImgs.我再试试,
          leftAction: this.cancel,
          leftReport: this.reportData.碰蛋结果弹框.我再试试
        };
      }
    },
    myResultText: function myResultText() {
      return this.currentAward.my.result ? this.setting.冠名 + "\u606D\u559C\u4F60\u78B0\u51FA\u4E86<span>".concat(this.currentAward.my.name, "</span>") : '什么？你啥都没碰出来...';
    },
    otherResultText: function otherResultText() {
      return this.currentAward.other.result ? "\u4F60\u7684\u597D\u53CB\u78B0\u51FA\u4E86<span>".concat(this.currentAward.other.name, "</span>") : '你的好友啥都没碰出来...';
    },
    未中奖奖品: function 未中奖奖品() {
      return window.setting.未中奖奖品;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.flickity = new Flickity(this.$refs.wrapper, {
      // options
      cellAlign: 'left',
      contain: true,
      draggable: false,
      pageDots: false,
      prevNextButtons: false,
      on: {
        change: function change(index) {
          _this.currentIndex = index;
        }
      }
    });
    this.$once('hook:beforeDestroy', function () {
      _this.flickity.destroy();
    });
  },
  methods: {
    toAwardPage: function toAwardPage() {
      this.openUrl('https://film.qq.com/weixin/v3/asset/#award');
    },
    cancel: function cancel() {
      this.$emit('hide');
    },
    share: function share() {
      this.$emit('share', this.currentAward);
    }
  }
};